import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { UserAuthPromiseService } from "../../../shared/cubiq-services/auth/impl/UserAuthPromiseService";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";

@Injectable()
export class ResetGuard {
  private isResetRequested: boolean = true;
  constructor(private _router: Router, protected _userAuthService: UserAuthPromiseService) {}

  canActivate(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this._userAuthService.isResetRequested().then((res) => {
        if (!res && !NativeDesktopSupport.logout(this._router, true)) {
          logger.out.info(`${this.constructor.name}.canActivate() isResetRequested()`);
          this._router.navigate(["not-authorized"]);
        }
        resolve(res);
      });
    });
  }
}
